import React from "react";
import { Eye, EyeOff, AlertCircle } from "lucide-react";

const AppInput = ({
  label,
  required = false,
  type = "text",
  value,
  onChange,
  placeholder,
  name,
  autoComplete,
  showPasswordToggle = false,
  showPassword = false,
  onTogglePassword,
  error = "",
}) => {
  const hasError = Boolean(error);

  return (
    <div className="w-full">

      {/* Label */}
      <label
        htmlFor={name}
        className="
          mb-2
          block
          text-[11px]
          font-semibold
          uppercase
          tracking-[0.08em]
          text-[#77818c]
        "
      >
        {label}{" "}
        {required && (
          <span className="text-[#c9942c]">*</span>
        )}
      </label>

      {/* Input wrapper */}
      <div className="relative w-full">

        <input
          id={name}
          className={`
            h-[47px]
            w-full
            rounded-[9px]
            border
            bg-white
            px-[15px]
            text-[13px]
            text-[#1d3441]
            outline-none
            transition-all
            duration-200
            placeholder:text-[#a5adb5]

            ${
              hasError
                ? `
                  border-[#e26b6b]
                  bg-[#fffafa]
                  pr-11
                  focus:border-[#dc5d5d]
                  focus:ring-4
                  focus:ring-[#dc5d5d]/[0.08]
                `
                : `
                  border-[#e1e3e5]
                  focus:border-[#294d5d]
                  focus:ring-4
                  focus:ring-[#294d5d]/[0.08]
                `
            }

            ${
              showPasswordToggle
                ? "pr-11"
                : ""
            }
          `}
          type={
            showPasswordToggle && showPassword
              ? "text"
              : type
          }
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          name={name}
          autoComplete={autoComplete}
          aria-invalid={hasError}
          aria-describedby={
            hasError ? `${name}-error` : undefined
          }
        />

        {/* Password toggle */}
        {showPasswordToggle && (
          <button
            type="button"
            onClick={onTogglePassword}
            aria-label={
              showPassword
                ? "Hide password"
                : "Show password"
            }
            className="
              absolute
              right-3
              top-1/2
              flex
              -translate-y-1/2
              items-center
              justify-center
              rounded-md
              border-none
              bg-transparent
              p-1
              text-[#89929a]
              transition-colors
              hover:bg-[#f5f6f7]
              hover:text-[#294d5d]
            "
          >
            {showPassword ? (
              <EyeOff size={16} />
            ) : (
              <Eye size={16} />
            )}
          </button>
        )}

        {/* Error icon */}
        {hasError && !showPasswordToggle && (
          <div
            className="
              pointer-events-none
              absolute
              right-3
              top-1/2
              flex
              -translate-y-1/2
              items-center
              justify-center
              text-[#dc5d5d]
            "
          >
            <AlertCircle size={17} />
          </div>
        )}

      </div>

      {/* Error message */}
      {hasError && (
        <div
          id={`${name}-error`}
          className="
            mt-1.5
            flex
            items-center
            gap-1.5
            text-[10px]
            font-medium
            text-[#d65c5c]
            animate-[fadeIn_0.2s_ease-in-out]
          "
        >
          <AlertCircle
            size={12}
            strokeWidth={2.2}
          />

          <span>{error}</span>
        </div>
      )}

    </div>
  );
};

export default AppInput;